import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderCrossPromoVkMusicSeveralSubscriptions = () => {
    openPopupHelper({
        popupName: popupNames.CROSS_PROMO_VK_MUSIC_SEVERAL_SUBSCRIPTIONS_MODAL,
    });
};
